import React, { useState } from 'react'
import Button from 'components/button'
import Select from 'components/select'
import IntegrationCard from 'views/integrations/components/IntegrationCard'
import { useApplicationStore } from 'hooks/application'
import { validateSourceUrl } from 'helpers/utils'
import { APP_URL, REVIZTO_REGIONS } from 'app-constants'

interface ReviztoConnectionProps {
  connected: boolean
  connectingAccount: boolean
  disconnectAccount: (provider: string) => void
  redirectUrl: string
  connectAccount: (provider: string, authorizationCode: string, region?: string) => void
}

const ReviztoConnection: React.FC<ReviztoConnectionProps> = ({
  connected,
  connectingAccount,
  disconnectAccount,
  redirectUrl,
  connectAccount
}) => {
  const [accessToken, setAccessToken] = useState<string>()
  const [region, setRegion] = useState<string>('')
  const { setSnackbarMessage } = useApplicationStore()

  return (
    <IntegrationCard
      provider="revizto"
      logo={validateSourceUrl(`${APP_URL}/assets/images/revizto.webp`)}
      connected={connected}
      connectingAccount={connectingAccount}
      disconnectAccount={disconnectAccount}
    >
      {!connected && (
        <div className="flex w-full flex-col gap-1.5">
          <Select
            options={Object.keys(REVIZTO_REGIONS).map((regionKey) => ({
              value: regionKey,
              label: REVIZTO_REGIONS[regionKey]
            }))}
            optionsSelected={region ? [region] : []}
            onOptionClick={(option) => setRegion(option)}
            placeholder="Select Region"
            menuWidth={280}
            className="py-[7px] px-2.5"
          />

          {accessToken === undefined && region !== '' && (
            <a href={redirectUrl} target="_blank" rel="noopener noreferrer" className="w-full">
              <Button
                className="w-full"
                disabled={connectingAccount}
                onClick={() => {
                  setAccessToken('')
                }}
              >
                Get Token
              </Button>
            </a>
          )}

          {accessToken === '' && region !== '' && (
            <Button
              className="w-full"
              disabled={connectingAccount}
              onClick={() => {
                const token = window.prompt('Enter your Revizto access token')
                if (token) {
                  connectAccount('revizto', token, region)
                } else {
                  setSnackbarMessage({
                    status: 'error',
                    message:
                      'No access code was entered. Select Enter Code and paste the code from Revizto to connect your account.'
                  })
                }
              }}
              data-tour="revizto-enter-access-code"
            >
              Enter Code
            </Button>
          )}
        </div>
      )}
    </IntegrationCard>
  )
}

export default ReviztoConnection
